import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RouterModule, Routes} from '@angular/router';
import {Section1Component} from './section1/section1.component';
import {Section2Component} from './section2/section2.component';
import {StartComponentComponent} from './start-component/start-component.component';
import {ScannerComponent} from './scanner/scanner.component';
import {EndComponent} from './end/end.component';

const routes: Routes = [
  {path: 'welcome', component: Section1Component},
  {path: 'start', component: StartComponentComponent},
  {path: 'scanner', component: ScannerComponent},
  {path: 'end/:locationId', component: EndComponent},
  {path: 'section/:sectionId/:locationId', component: Section2Component},
  {path: '', redirectTo: '/welcome', pathMatch: 'full'}
];

@NgModule({
  declarations: [],
  imports: [
    RouterModule.forRoot(routes),
    CommonModule
  ],
  exports: [
    RouterModule
  ]
})
export class AppRoutingModule {


}
